import { Carousel } from './carousel';

const carousel = new Carousel({
  controllerPrev: document.querySelector('.worksheets-slider__control--prev') as HTMLButtonElement,
  controllerNext: document.querySelector('.worksheets-slider__control--next') as HTMLButtonElement,
  listClassName: 'worksheets-slider__list',
  trackNode: document.querySelector('.worksheets-slider__track'),
});

carousel.init();
